<div class="notification-flier">
    <div *ngFor="let item of notifications" class="notification-bar notification-status-{{NotificationStatus[item.status]}}">
        <div class="status-icon">
            <i class='csx-common_stop' *ngIf="NotificationStatus[item.status] != 'SUCCESS' && NotificationStatus[item.status] != 'PENDING'"></i>
            <i class='csx-common_info' *ngIf="NotificationStatus[item.status] == 'SUCCESS' || NotificationStatus[item.status] == 'PENDING'"></i>
        </div>
        <div class="status-text"><span title="{{item.message}}">{{item.message}}</span></div>
        <div class="x-loader-wrapper" *ngIf="NotificationStatus[item.status] == 'PENDING'">
            <div class="x-loader x-loader-default"></div>
        </div>
        <div class="status-dismiss" (click)="dismiss(item)"  *ngIf="NotificationStatus[item.status] != 'PENDING'">
            <i class="csx-common_delete"></i>
        </div>
    </div>
</div>